
import React from 'react';

const companyDetails = [
    { label: '社名', value: '株式会社AgLab（エージーラボ）' },
    { label: '設立', value: '2025年2月7日' },
    { label: '代表者', value: '代表取締役　相川 直輝' },
    { label: '従業員数', value: '40名（アルバイト・パート含む）' },
    { label: '事業内容', value: '・AI研修事業<br>・AIコンサル事業<br>・AI開発事業<br>・スクール事業<br>・クリエイティブ制作事業<br>・AItuber事業<br>・HR事業' },
    { label: '厚生労働大臣許可番号', value: '有料職業紹介事業 13-ユ-319587' },
    { label: '所在地', value: '〒107-0061<br>東京都港区北青山2-7-26 Landwork青山ビル2階' },
    { label: 'メールアドレス', value: 'info@aglab.co.jp' },
    { label: 'TEL', value: '03-6434-7778 (代表)' },
    { label: 'グループ会社', value: '株式会社Anyglo（エニーグロー）<br><a href ="https://anyglo.co.jp/" class="text-blue-600 hover:underline">https://anyglo.co.jp/</a>' },
];
const CompanyPage: React.FC = () => (
    <div className="pt-20 bg-gray-50 min-h-screen">
        <header className="bg-white py-16 text-center border-b">
            <div className="container mx-auto px-6">
                <h1 className="text-4xl md:text-5xl font-extrabold text-[#3aabd2]">Company</h1>
                <p className="mt-2 text-lg text-gray-600">会社概要</p>
            </div>
        </header>
        <section className="py-20">
            <div className="container mx-auto px-6">
                <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-lg overflow-hidden border border-gray-200">
                    <table className="w-full text-left">
                        <tbody>
                            {companyDetails.map((item, index) => (
                                <tr key={index} className="border-b border-gray-200 last:border-b-0">
                                    <th className="w-1/3 text-sm sm:text-base font-semibold text-gray-800 bg-gray-50 p-4 align-top">{item.label}</th>
                                    <td className="p-4 text-sm sm:text-base text-gray-700" dangerouslySetInnerHTML={{ __html: item.value }}></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    </div>
);

export default CompanyPage;
